var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toastfade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.showMsg? 'nut-toastHov' : 'nut-toast'},[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }